import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { ToggleButton } from '../../../../components/ToggleButton';
import { Tooltip } from '../../../../components/Tooltip';
import type { GroupedMetrics } from '../../../../domain/preferences';

import { StyledMetricsWrapper, StyledMetricsHeader } from './styles';

export type MetricsGroupsProps = {
  groupedMetrics: GroupedMetrics;
  selectedMetrics: string[];
  onMetricClick(metric: string): void;
};

export const MetricsGroups = ({ groupedMetrics, selectedMetrics, onMetricClick }: MetricsGroupsProps) => {
  const { t } = useTranslation();

  return (
    <>
      {Object.entries(groupedMetrics).map(([title, metrics]) => (
        <div key={title}>
          <StyledMetricsHeader>
            {title}
            <Tooltip
              content={t(`insights.preferences.metrics.${title.toLowerCase()}.tooltip`)}
              placement="right"
              minWidth={200}
            >
              <SWReactIcons iconName="info" size="12px" iconColor={colorsPalettes.carbon[250]} />
            </Tooltip>
          </StyledMetricsHeader>

          <StyledMetricsWrapper>
            {metrics.map(({ label, metric }) => (
              <ToggleButton
                key={metric}
                onClick={() => onMetricClick(metric)}
                isSelected={selectedMetrics.includes(metric)}
              >
                {label}
              </ToggleButton>
            ))}
          </StyledMetricsWrapper>
        </div>
      ))}
    </>
  );
};
